import { Plus } from 'lucide-react';

export function AddButton(props: {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      className="mx-0.5 flex size-6 cursor-pointer appearance-none items-center justify-center rounded-md border border-slate-200 bg-white p-0 text-slate-500 shadow-none ring-0 transition-colors outline-none hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700 focus-visible:border-sky-200 focus-visible:bg-sky-50 focus-visible:text-sky-700 disabled:pointer-events-none disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-300"
      style={{ boxShadow: 'none' }}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <Plus className="size-3.5" />
    </button>
  );
}
